<template>
    <div class="container-fluid max-container">
    <div class="form-checkout-container d-flex justify-content-center align-items-center flex-column padding-6">
      <!-- VeeValidate Form -->
       <div class="d-flex justify-content-center align-items-center flex-column">
         <img src="@/assets/success.svg" class="gap-4" />
         <p class="font-success">Payment Successful !</p>
         <p class="order-desc payment">Your order has been successfully placed, and a confirmation sent to your email address. If you need any help please contact help@livingdna.com</p>
       </div>
      <router-link :to="{ name: 'dashboard' }" class="back-button">Back To Home</router-link>
      <router-link :to="{ name: 'HealthStore' }" class="back-button">Back To Store</router-link>
    </div>
    </div>
</template>
<script setup>

</script>